/**
 * VERSIONE LIBRERIA 3
 * classe Interfaccia verso i vari componenti
 */

var Facade = {
    confs : null,
    controller : null,
    viewContainers : {},
    viewIds : {},
    renders : {}, // render generici fuori da ogni view
    role : null,
    tagNames :'viewlist,viewedit,viewview,viewcalendar,viewsearch,viewinsert',
    baseUrl : '',
    version : '3.0',

    init : function () {
        var self = this;
        self.confs = new Confs();
        self.controller = new Controller();
    },

    loadConf : function(modelName,type,callback) {
        var self = this;
        var script_url = "/js/ModelsConfs/" + modelName + ".js";
        Utility.loadScript(self.getUrl(script_url),function () {
            callback(self.confs.getConf(modelName,type,self.role));
        });
    },
    getConf : function(modelName,type,callback) {
        var self = this;
        return self.confs.getConf(modelName,type,self.role);
    },

    getKeyFromId : function (htmlId) {
        return this.viewIds[htmlId];
    },
    removeViewById : function (htmlId) {
        return this.removeView(this.getKeyFromId(htmlId));
    },
    removeView : function(key) {
        // constrollo che non esiste la key negli id html, altrimenti rimuovo anche da li'.
        for (var k in this.viewIds) {
            if (key == this.viewIds[k]) {
                delete this.viewIds[k];
                break;
            }
        }
        this.controller.removeView(key);
    },
    renderViewById : function (htmlId,callback) {
        this.controller.renderView(this.getKeyFromId(htmlId),callback);
    },
    renderView : function (key,callback) {
        this.controller.renderView(key,callback);
    },
    getViewById : function(htmlId) {
        return this.getView(this.getKeyFromId(htmlId));
    },
    getView : function (key) {
        return this.controller.getView(key);
    },

    //createList : function(modelName,container,conf) {
    createList : function(viewConf) {
        var self = this;
        var modelConf = viewConf.vConf?viewConf.vConf:self.getConf(viewConf.model,'list');
        modelConf.langs = self.confs.getLangs();
        modelConf.container = viewConf.container;
        var routeType = modelConf.routeType ? modelConf.routeType : 'list';
        //console.log("LIST ROUTTYEP ",routeType,modelConf,modelConf.routeType,(modelConf.routeType ? modelConf.routeType : 'list'));
        var vkey = null;
        viewConf.vConf = modelConf;
        // se esiste gia' una view associata all'id del container non la creo ma risetto le conf
        if (jQuery(modelConf.container).attr('id')) {
            vkey = self.getKeyFromId(jQuery(modelConf.container).attr('id'));
            if (vkey) {
                var view = self.controller.getView(vkey);
                if (view)
                    view.config = modelConf;
                return vkey;
            }
        }
        var viewClass = viewConf.viewClass?viewConf.viewClass:'ViewList';
        vkey = self.controller.addView(viewClass,{
            config : modelConf,
            modelName : viewConf.model,
            routeParams : {
                model : viewConf.model,
                constraintValue : modelConf.constraintValue,
                constraintKey : modelConf.constraintKey,
            },
            routeType:routeType,
            constraint : modelConf.constraint?modelConf.constraint:null,
        });

        //self.controller.renderView(vkey);
        return vkey;

    },

    createEdit : function(viewConf) { //function (modelName,pk,container,conf) {
        var self = this;
        var modelConf = null;
        var routeType = null;
        if (viewConf.pk) {
            modelConf = viewConf.vConf?viewConf.vConf:self.confs.getConf(viewConf.model,'edit',self.role); //new SearchConfs();
            routeType = modelConf.routeType ? modelConf.routeType : 'edit';
        } else {
            modelConf = viewConf.vConf?viewConf.vConf:self.confs.getConf(viewConf.model,'insert',self.role);
            routeType =  modelConf.routeType ? modelConf.routeType : 'insert';
        }


        modelConf.langs = self.confs.getLangs();
        modelConf.container = viewConf.container;
        viewConf.vConf = modelConf
        var viewClass ="ViewEdit";
        if (!viewConf.viewClass) {
            if (modelConf.groups) {
                var groupLength = _.keys(modelConf.groups).length;
                viewClass = viewClass += 'G' + groupLength;
            }
        } else {
            viewClass = viewConf.viewClass;
        }

        var vkey = self.controller.addView(viewClass,{
            config : modelConf,
            modelName : viewConf.model,
            pk : viewConf.pk,
            routeParams : {
                model : viewConf.model,
                pk : viewConf.pk,
                constraintValue : modelConf.constraintValue,
                constraintKey : modelConf.constraintKey,
            },
            routeType : routeType,
            constraint : modelConf.constraint?modelConf.constraint:null,
        });

        //self.controller.renderView(vkey);
        return vkey;
    },

    createView : function (modelName,pk,container,conf) {
        var self = this;
        var vConf = conf?conf:self.confs.getConf(modelName,'view',self.role); //new SearchConfs();;
        vConf.langs = self.confs.getLangs();
        var routeType = vConf.routeType ? vConf.routeType : 'view';;
        vConf.container = container;
        var viewClass ="ViewView";

        if (!conf.viewClass) {
            if (vConf.groups) {
                var groupLength = _.keys(vConf.groups).length;
                viewClass = viewClass += 'G' + groupLength;
            }
        } else {
            viewClass = conf.viewClass;
        }

        var vkey = self.controller.addView(viewClass,{
            config : vConf,
            modelName : modelName,
            pk : pk,
            routeParams : {
                model : modelName,
                pk : pk,
                constraintValue : vConf.constraintValue,
                constraintKey : vConf.constraintKey,
            },
            routeType : routeType,
            constraint : vConf.constraint?vConf.constraint:null,
        });

        //self.controller.renderView(vkey);
        return vkey;
    },

    createCsv : function(modelName,providerName,container,conf) {
        var self = this;
        var vConf = conf?conf:self.confs.getConf(modelName,'csv',self.role); //new SearchConfs();;
        var routeType =  vConf.routeType ? vConf.routeType : 'csv';
        vConf.langs = self.confs.getLangs();
        vConf.container = container;
        var viewClass ="ViewCsv";

        if (!conf.viewClass) {
            if (vConf.groups) {
                var groupLength = _.keys(vConf.groups).length;
                viewClass = viewClass += 'G' + groupLength;
            }
        } else {
            viewClass = conf.viewClass;
        }

        vConf.providerName = providerName;
        var vEditKey = self.controller.addView(viewClass,{
            config : vConf,
            modelName : modelName,
            routeParams : {
                model : modelName,
            },
            routeType : routeType
        });
        self.controller.mainViewKey = vEditKey;
        return vEditKey;
        //controller.getView(vEditKey).routeType = 'edit';
        //controller.renderView(vEditKey);
        //self.controllerCsv.renderViews();
    },

    createSearch : function(modelName,container,conf) {
        var self = this;
        var vConf = conf?conf:self.confs.getConf(modelName,'search',self.role); //new SearchConfs();;
        vConf.langs = self.confs.getLangs();
        vConf.container = container;
        var routeType = vConf.routeType ? vConf.routeType : 'search';
        var viewClass = "ViewSearch";

        //UN TROIAIO DA EVENTUALMENTE SISTEMARE MEGLIO PER PANNELLO ADVANCED
        if (!conf.viewClass) {
            if (vConf.groups) {
                var groupLength = _.keys(vConf.groups).length;
                viewClass = viewClass += 'G' + groupLength;
            }
        } else {
            viewClass = conf.viewClass;
        }
        var vkey = self.controller.addView(viewClass,{
            config : vConf,
            modelName : modelName,
            routeParams : {
                model : modelName,
            },
            routeType : routeType
        });

        //self.controller.renderView(vkey);
        return vkey;

    },

    //createInsert : function(modelName,container,conf) {
    createInsert : function(vConf) {
        var self = this;
        return self.createEdit(vConf);
    },

    createCalendar : function(modelName,container,conf) {
        var self = this;
        var vConf = conf?conf:self.confs.getConf(modelName,'calendar',self.role); //new SearchConfs();;
        vConf.langs = self.confs.getLangs();
        vConf.container = container;
        var routeType = vConf.routeType ? vConf.routeType : 'calendar';
        var viewClass ="ViewCalendar";

        if (!conf.viewClass) {
            if (vConf.groups) {
                var groupLength = _.keys(vConf.groups).length;
                viewClass = viewClass += 'G' + groupLength;
            }
        } else {
            viewClass = conf.viewClass;
        }

        var vkey = self.controller.addView(viewClass,{
            config : vConf,
            modelName : modelName,
            routeParams : {
                model : modelName,
            },
            routeType : routeType
        });

        //self.controller.renderView(vkey);
        return vkey;

    },

    createTree : function(modelName,container,conf) {
        var self = this;
        var vConf = conf?conf:self.confs.getConf(modelName,'tree',self.role); //new SearchConfs();;
        vConf.langs = self.confs.getLangs();
        vConf.container = container;
        var routeType = vConf.routeType ? vConf.routeType : 'tree';
        var viewClass ="ViewTree";

        if (!conf.viewClass) {
            if (vConf.groups) {
                var groupLength = _.keys(vConf.groups).length;
                viewClass = viewClass += 'G' + groupLength;
            }
        } else {
            viewClass = conf.viewClass;
        }

        var vkey = self.controller.addView(viewClass,{
            config : vConf,
            modelName : modelName,
            routeParams : {
                model : modelName,
            },
            routeType : routeType
        });

        //self.controller.renderView(vkey);
        return vkey;

    },

    createIframe : function (conf) {
        conf.width = conf.width?conf.width:'100%';
        conf.height = conf.height?conf.height:parseInt(jQuery(window).height()*.85)+'px';
        conf.title = conf.title?conf.title:' ';
        var string = '<iframe style="width:'+conf.width+';height:'+ conf.height +';" src="'+ conf.url +'"></iframe>';
        jQuery('#generalDialog .modal-body').html(string);
        jQuery.generalDialog(null, {title: conf.title, hide_buttons: true});
    },
    createIframeTab : function (conf) {
        var self = this;
        var url = '/ajaxtab/' + conf.modelName;
        url += conf.constraintKey?'/'+conf.constraintKey+"/"+conf.constraintValue:'';
        conf.url = url;
        conf.title = conf.title?conf.title:jQuery.translate('model-'+conf.modelName);
        return self.createIframe(conf);
    },

    createModal : function (model,type,title,attrs,callback) {
        var id = "rand_" + Math.floor((Math.random() * 10000) + 1);
        var viewHtml = '<' + type + ' id="' + id + '" model="' + model + '" ';
        if (attrs) {
            for(var k in attrs) {
                viewHtml += k + '="'+attrs[k]+'" ';
            }
        }

        viewHtml += '></'+type+'>';
        jQuery('#generalDialog .modal-body').html(viewHtml);
        Facade.parse('#generalDialog');
        var titolo = title?title:model;
        jQuery.generalDialog(null,{title: titolo, hide_buttons: true})
        jQuery('#generalDialog').on('hidden.bs.modal', function () {
            var key = Facade.getKeyFromId(id);
            if (key)
                Facade.removeView(key);
            if (callback)
                callback();
        })
    },

    parse : function (container) {
        var self = this;
        self._createController();
        var realContainer = container?container:'body';
        log.debug("Facade.parse " + realContainer);
        var new_keys = [];
        jQuery.each(jQuery(realContainer).find(self.tagNames),function () {
            var key = null;
            switch (jQuery(this).prop('tagName')){
                case 'VIEWLIST':
                    key = self._createList($(this));
                    break;
                case 'VIEWSEARCH':
                    key = self._createSearch($(this));
                    break;
                case 'VIEWEDIT':
                    key = self._createEdit($(this));
                    break;
                case 'VIEWINSERT':
                    key = self._createInsert($(this));
                    break;
                case 'VIEWVIEW':
                    key = self._createView($(this));
                    break;
                case 'VIEWCALENDAR':
                    key = self._createCalendar($(this));
                    break;
                case 'VIEWTREE':
                    key = self._createTree($(this));
                    break;
            }
            new_keys.push(key);
            //jQuery(this).attr('vkey',key);
            self.viewContainers[key] = $(this);
            if (jQuery(this).attr('id'))
                self.viewIds[$(this).attr('id')] = key;
        });
        // connetto solo le view nuove che sono state inserite
        self.connectActions(new_keys);
    },
    /**
     * controlla che se le views hanno delle azioni che le connettano ed esegue
     * le connesioni.
     * @param keys : vettore di chiavi di view
     */
    connectActions : function (keys) {
        var self = this;
        log.debug('connect actions',keys);
        for(var i in keys) {
            var vKey = keys[i];
            log.debug('check ' + vKey + " connetctions");
            var connect_actions = self.viewContainers[vKey].attr('connect_actions') ? self.viewContainers[vKey].attr('connect_actions') : null;
            if (!connect_actions)
                continue;

            connect_actions = JSON.parse(connect_actions);
            log.debug('found ',connect_actions);
            //console.log('ACCCCCCIONSTTTSSS',connect_actions);
            for (var a in connect_actions) {
                var id = connect_actions[a];
                console.log('id',id,'a',a,self.viewIds[''+id]);
                if (self.viewIds[''+id]) {
                    console.log("connect",vKey,'to',{key:self.viewIds[id],action:a});
                    self.controller.connectView(vKey,{key:self.viewIds[id],action:a});
                }
            }
            //controller.connectView(vSearchKey,{key : vListKey,action:'search'});
        }
    },
    parseRender : function (container,callback) {
        var self = this;
        log.debug("Facade.parseRender");
        container = container?container:'body';
        $.each($(container).find('render'),function () {
            var attrs = self._getRenderAttributes($(this));
            self.renders[attrs.key] = Render.factory(attrs.key,attrs,attrs.type);
            self.renders[attrs.key].render();
            self.renders[attrs.key].finalize();
        })
        if (callback)
            callback()
    },
    _createList : function (jQe) {
        var self = this;
        var viewConf = self._getStandardAttributes(jQe,'list');
        viewConf.vConf.pagination =jQe.attr('pagination')?JSON.parse(jQe.attr('pagination')):true;
        var vkey = self.createList(viewConf);
        if (viewConf.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },
    _createSearch : function (jQe) {
        var self = this;
        var attr = self._getStandardAttributes(jQe,'search');
        var vkey = self.createSearch(attr.model,jQe,attr.vConf);
        if (attr.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },
    _createInsert: function(jQe) {
        var self = this;
        var viewConf = self._getStandardAttributes(jQe,'insert');
        var vkey = self.createInsert(viewConf);
        if (viewConf.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },
    _createEdit : function (jQe) {
        var self = this;
        var viewConf = self._getStandardAttributes(jQe,'edit');
        var vkey = self.createEdit(viewConf);
        if (viewConf.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },

    _createView : function (jQe) {
        var self = this;
        var attr = self._getStandardAttributes(jQe,'view');
        attr.vConf.container = jQe;
        var viewClass ="ViewView";
        if (attr.vConf.groups) {
            var groupLength = _.keys(attr.vConf.groups).length;
            attr.vConf.templateId = '#default_view_edit_group'+groupLength+'_tpl';
            viewClass ='ViewViewG'+groupLength;
        }
        var viewConfig = {
            config: attr.vConf,
            modelName: attr.model,
            routeParams: {
                model: attr.model,
                pk : attr.pk
            },
            pk : attr.pk
        };
        var vkey = self.controller.addView(viewClass,viewConfig);
        if (attr.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },
    _createCalendar : function (jQe) {
        var self = this;
        var attr = self._getStandardAttributes(jQe,'calendar');
        attr.vConf.container = jQe;
        var viewClass ="ViewCalendar";
        var viewConfig = {
            config: attr.vConf,
            modelName: attr.model,
            routeParams: {
                model: attr.model,
                pk : attr.pk
            },
            pk : attr.pk
        };
        var vkey = self.controller.addView(viewClass,viewConfig);
        if (attr.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },
    _createTree : function (jQe) {
        var self = this;
        var attr = self._getStandardAttributes(jQe,'tree');
        attr.vConf.container = jQe;
        var viewClass ="ViewTree";
        var viewConfig = {
            config: attr.vConf,
            modelName: attr.model,
            routeParams: {
                model: attr.model,
                pk : attr.pk
            },
            pk : attr.pk
        };
        var vkey = self.controller.addView(viewClass,viewConfig);
        if (attr.autorender)
            self.controller.renderView(vkey);
        jQe.attr('vkey',vkey);
        return vkey;
    },
    _getStandardAttributes: function(jQe,type) {
        var self = this;
        var attr = {};
        attr.model = jQe.attr('model');
        attr.container = jQe;
        attr.vConf = jQe.attr('conf')?jQe.attr('conf'):null;
        if (attr.vConf) {
            log.debug(attr.model + ' loading custom conf ' + attr.vConf);
            attr.vConf = new window[attr.vConf]();
        } else
            attr.vConf = self.confs.getConf(attr.model,type,self.role); //new SearchConfs();
        attr.vConf.custom = jQe.attr('custom')?jQe.attr('custom'):null;
        attr.vConf.customTemplate = jQe.attr('customTemplate')?jQe.attr('customTemplate'):null;
        attr.pk = jQe.attr('pk')?jQe.attr('pk'):null;
        attr.vConf.langs = self.confs.langs?self.confs.langs:['it'];
        attr.vConf.constraintKey = jQe.attr("constraintKey")?jQe.attr("constraintKey"):null;
        attr.vConf.constraintValue = jQe.attr("constraintValue")?jQe.attr("constraintValue"):null;
        attr.autorender = jQe.attr('autorender')?JSON.parse(jQe.attr('autorender')):true;
        attr.afterRender = jQe.attr('afterRender')?JSON.parse(jQe.attr('afterRender')):null;
        attr.vConf.constraint=attr.vConf.constraintKey && attr.vConf.constraintValue?'Constraint':null;
        attr.vConf.routeType = jQe.attr('routeType')?jQe.attr('routeType'):null;
        attr.vConf.prefixTemplateClass = jQe.attr('prefixTemplateClass')?jQe.attr('prefixTemplateClass'):null;
        attr.viewClass = jQe.attr('viewClass')?jQe.attr('viewClass'):null;
        //attr.vConf.
        if (jQe.attr('actions')) {
            attr.vConf.actions = jQe.attr('actions').split(",");
        }
        log.debug('Facade._getStandardAttributes',attr);
        return attr;
    },

    _getRenderAttributes : function (jQe) {
        var attr = {};
        attr.key = jQe.attr('key');
        attr.type = jQe.attr('type');
        attr.container = '#'+ jQe.attr('id');
        attr.mode = 'edit';
        var conf = jQe.attr('conf')?window[jQe.attr('conf')]:{};
        attr = _.extendOwn(attr,conf);
        return attr;
    },
    _createController : function () {
        var self = this;
        if (!self.controller)
            self.controller = new Controller();
    },
    /**
     * crea il prefisso in caso il sito venga ospitato in una sottocartella dell'host principale
     *
     * @param baseUrl
     */
    setBaseUrl : function (baseUrl) {
        this.baseUrl = baseUrl;
    },

    getUrl : function(url) {
       return this.baseUrl + url;
    }


}

// INIZIALIZZAZIONE FACADE

Facade.init();
